import React, { useMemo } from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { iaRa } from 'lib/helpers/utility';

import TableRow from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/components/TableRow';

import TableHeaderRow from '../ReceiptTable/components/TableHeaderRow';

import { TRANSACTIONS_TABLE_COLUMNS } from './columnDefs';

const TransactionsTable = ({ transactions, timezone }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const columns = useMemo(() => TRANSACTIONS_TABLE_COLUMNS(timezone), [timezone]);
  const visibleColumns = useMemo(() => columns.filter((col) => !col.hide), [columns]);

  if (isMobile) return null;

  return (
    <table className="h-fit w-full table-fixed border-collapse [&_td]:p-1.5 [&_th]:p-1.5">
      <colgroup>
        {visibleColumns.map((col, idx) => (
          <col
            key={idx}
            style={{
              minWidth: col.minWidth,
              width: col.width || `${100 / visibleColumns.length}%`
            }}
          />
        ))}
      </colgroup>
      <thead>
        <TableHeaderRow columnDefs={visibleColumns} className="bg-neutral-50" />
      </thead>
      <tbody>
        {iaRa(transactions).map((transaction, index) => (
          <TableRow
            key={transaction.id}
            row={transaction}
            columnDefs={visibleColumns}
            className="border-0 border-b border-solid border-neutral-200"
            cellClassName="p-1.5"
            idx={index}
            preview
          />
        ))}
      </tbody>
    </table>
  );
};

export default TransactionsTable;
